export const enum DisplayType {
  /** 0 : スワイプボタン大 */
  FORM = 0,
  /** 1 : スワイプボタン小 */
  MODAL = 1
}
